import { render, staticRenderFns } from "./FormAddPlanNew.vue?vue&type=template&id=0214fb28&scoped=true"
import script from "./FormAddPlanNew.vue?vue&type=script&lang=js"
export * from "./FormAddPlanNew.vue?vue&type=script&lang=js"
import style0 from "./FormAddPlanNew.vue?vue&type=style&index=0&id=0214fb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214fb28",
  null
  
)

export default component.exports